import { Component } from 'react';

import { User } from 'apis/restaurant-api/merchant-admin/user/types';

import { canUseDOM, createUserForIntercom, localWindow } from './utils';

type Props = {
  appID: string;
  user: User;
  iconAlignment: 'left' | 'right';
  isLauncherHidden?: boolean;
};

let isIntercomBooted = false;

const configureIntercom = (props: Props, update: boolean = false) => {
  const { appID, user, iconAlignment } = props;

  const intercomUser = createUserForIntercom(user);

  if (intercomUser.user_id === '') {
    return;
  }
  const intercomSettings = {
    ...intercomUser,
    app_id: appID,
    hide_default_launcher: props.isLauncherHidden,
    alignment: iconAlignment,
  };

  // localWindow.intercomSettings is used to manage the client
  // https://developers.intercom.com/installing-intercom/docs/basic-javascript
  localWindow.intercomSettings = intercomSettings;

  if (!isIntercomBooted) {
    if (localWindow.Intercom) {
      localWindow.Intercom('boot', intercomSettings);
      isIntercomBooted = true;
    }
  }

  if (update && localWindow.Intercom) {
    localWindow.Intercom('update', intercomUser);
  }
};

export default class Intercom extends Component<Props, any> {
  static displayName = 'Intercom';

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    const { appID } = this.props;

    if (!appID || !canUseDOM) {
      return;
    }

    if (!localWindow.Intercom) {
      ((windowObject, documentSymbol, id) => {
        const intercomObject: any = (...args: any[]) => {
          intercomObject.c(args);
        };
        intercomObject.q = [];
        intercomObject.c = (args: any) => {
          intercomObject.q.push(args);
        };
        windowObject.Intercom = intercomObject;

        const script = documentSymbol.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://widget.intercom.io/widget/${id}`;
        const [scriptContent] = documentSymbol.getElementsByTagName('script');
        if (scriptContent.parentNode) {
          scriptContent.parentNode.insertBefore(script, scriptContent);
        }
      })(localWindow, document, appID);
    }

    configureIntercom(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!canUseDOM) {
      return;
    }
    configureIntercom(nextProps, true);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM) {
      return false;
    }

    localWindow.Intercom('shutdown');
    isIntercomBooted = false;
    delete localWindow.Intercom;

    return false;
  }

  render() {
    return null;
  }
}
